(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loved-by"] && !Shopify.designMode) return;
  try {
    
class LovedByCarousel {
  constructor(section) {
    this.section = section;
    this.slides = section.querySelectorAll('.loved-by__slide');
    this.dots = section.querySelectorAll('.loved-by__dot');
    this.current = 0;
    this.interval = null;

    section.querySelectorAll('.loved-by__dot').forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i));
    });
    section.querySelector('.loved-by__prev')?.addEventListener('click', () => this.prev());
    section.querySelector('.loved-by__next')?.addEventListener('click', () => this.next());

    this.show(0);
    this.startAutoplay();
    section.addEventListener('mouseenter', () => this.stopAutoplay());
    section.addEventListener('mouseleave', () => this.startAutoplay());
  }

  show(idx) {
    this.slides.forEach((s, i) => s.classList.toggle('active', i === idx));
    this.dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    this.current = idx;
  }

  next() { this.goTo((this.current + 1) % this.slides.length); }
  prev() { this.goTo((this.current - 1 + this.slides.length) % this.slides.length); }
  goTo(idx) { this.show(idx); }

  startAutoplay() {
    this.stopAutoplay();
    this.interval = setInterval(() => this.next(), 5000);
  }
  stopAutoplay() { if (this.interval) { clearInterval(this.interval); this.interval = null; } }
}

document.querySelectorAll('[data-section-type="loved-by"]').forEach(section => {
  new LovedByCarousel(section);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shezair-home-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('shz-proof-marquee')){
 customElements.define('shz-proof-marquee',class extends HTMLElement{
  connectedCallback(){
   this.group=this.querySelector('.shz-home-proof__group');
   this.copy=this.querySelector('.shz-home-proof__group[aria-hidden="true"]');
   if(!this.group||!this.copy)return;
   this.originals=Array.from(this.group.children).map(el=>el.cloneNode(true));
   this.refresh=()=>{
    this.group.replaceChildren(...this.originals.map(el=>el.cloneNode(true)));
    const baseWidth=this.group.getBoundingClientRect().width;
    if(!baseWidth)return;
    const repeats=Math.max(1,Math.ceil(this.clientWidth/baseWidth));
    for(let n=1;n<repeats;n++)this.originals.forEach(el=>{const clone=el.cloneNode(true);clone.setAttribute('aria-hidden','true');this.group.append(clone)});
    this.copy.replaceChildren(...Array.from(this.group.children).map(el=>el.cloneNode(true)));
   };
   this.refresh();this.observer=new ResizeObserver(this.refresh);this.observer.observe(this);
   document.fonts.ready.then(()=>{if(this.isConnected)this.refresh()});
  }
  disconnectedCallback(){this.observer?.disconnect()}
 });
}
if(!customElements.get('shezair-home-carousel')){customElements.define('shezair-home-carousel',class extends HTMLElement{connectedCallback(){this.slides=Array.from(this.querySelectorAll('[data-shz-slide]'));this.dots=Array.from(this.querySelectorAll('[data-shz-dot]'));this.current=0;this.duration=Math.max(Number(this.dataset.duration)||7000,4000);this.reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');this.dots.forEach(dot=>dot.addEventListener('click',()=>{this.activate(Number(dot.dataset.shzDot));this.restart()}));this.addEventListener('mouseenter',()=>this.stop());this.addEventListener('mouseleave',()=>this.start());this.addEventListener('focusin',()=>this.stop());this.addEventListener('focusout',()=>this.start());this.visibilityHandler=()=>document.hidden?this.stop():this.start();document.addEventListener('visibilitychange',this.visibilityHandler);this.start()}disconnectedCallback(){this.stop();document.removeEventListener('visibilitychange',this.visibilityHandler)}hydrate(slide){const image=slide&&slide.querySelector('.shz-home-slide__image');if(!image)return;if(image.dataset.srcset){image.srcset=image.dataset.srcset;delete image.dataset.srcset}if(image.dataset.src){image.src=image.dataset.src;delete image.dataset.src}}activate(index){if(!this.slides.length)return;this.current=(index+this.slides.length)%this.slides.length;this.hydrate(this.slides[this.current]);this.slides.forEach((slide,i)=>{const active=i===this.current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',active?'false':'true');slide.inert=!active});this.dots.forEach((dot,i)=>{const active=i===this.current;dot.classList.toggle('is-active',active);dot.setAttribute('aria-current',active?'true':'false')})}start(){if(this.slides.length<2||this.reduceMotion.matches||document.hidden||this.timer)return;this.timer=window.setInterval(()=>this.activate(this.current+1),this.duration)}stop(){window.clearInterval(this.timer);this.timer=null}restart(){this.stop();this.start()}})}

  } catch(e) { console.error(e); }
})();
})();
